// Finance ledger kept in the browser until the backend endpoints exist.
// Same shape the API will use, so swapping storage later only touches this file.

const STORAGE_KEY = 'izm.finance.transactions';
const SEEDED_KEY = 'izm.finance.seeded';

export const INCOME_CATEGORIES = ['contributions', 'offerings', 'pilgrimage_fees', 'fundraising', 'grants', 'other_income'];
export const EXPENSE_CATEGORIES = ['transport', 'accommodation', 'food', 'liturgy', 'communication', 'charity', 'allowances', 'fees', 'equipment', 'other_expense'];
export const METHODS = ['cash', 'mobile_money', 'bank_transfer', 'card', 'cheque'];

function daysAgo(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString().slice(0, 10);
}

// Example entries so the page has something to show in a demo.
function sampleTransactions() {
  const rows = [
    { type: 'income', date: daysAgo(2), amount: 620000, category: 'pilgrimage_fees', source: 'Pilgrims — Kibeho, last Sunday', destination: 'MoMo account', method: 'mobile_money', reference: 'XP-RSV-1029', description: 'Website bookings for the monthly pilgrimage' },
    { type: 'expense', date: daysAgo(3), amount: 360000, category: 'transport', source: 'MoMo account', destination: 'Volcano Express (3 buses)', method: 'mobile_money', reference: 'INV-2231', description: 'Bus hire, Kigali – Kibeho round trip' },
    { type: 'income', date: daysAgo(6), amount: 150000, category: 'contributions', source: 'Members — monthly contributions', destination: 'Cash box', method: 'cash', reference: 'RC-0412', description: 'Contributions collected after Mass' },
    { type: 'expense', date: daysAgo(7), amount: 85000, category: 'food', source: 'Cash box', destination: 'Kibeho Café', method: 'cash', reference: 'RC-0413', description: 'Lunch for drivers and volunteers' },
    { type: 'income', date: daysAgo(12), amount: 200000, category: 'offerings', source: 'Anonymous benefactor', destination: 'Bank account (BK)', method: 'bank_transfer', reference: 'BK-778120', description: 'Offering for the Christmas retreat' },
    { type: 'expense', date: daysAgo(15), amount: 45000, category: 'communication', source: 'Cash box', destination: 'Imprimerie Saint Paul', method: 'cash', reference: 'INV-0981', description: 'Printing of prayer booklets' },
    { type: 'expense', date: daysAgo(20), amount: 60000, category: 'charity', source: 'Bank account (BK)', destination: 'Family support — Nyamirambo', method: 'bank_transfer', reference: 'BK-776004', description: 'Support to a member family in need' },
    { type: 'expense', date: daysAgo(21), amount: 3500, category: 'fees', source: 'MoMo account', destination: 'MTN Rwanda', method: 'mobile_money', reference: 'MTN-FEE', description: 'Transfer charges' },
  ];
  return rows.map((r, i) => ({
    ...r,
    id: `fin-sample-${i + 1}`,
    code: `FIN-${String(i + 1).padStart(4, '0')}`,
    recordedBy: 'Sample data',
    sample: true,
    createdAt: new Date().toISOString(),
  }));
}

export function loadTransactions() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
    if (!localStorage.getItem(SEEDED_KEY)) {
      localStorage.setItem(SEEDED_KEY, '1');
      const seeded = sampleTransactions();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(seeded));
      return seeded;
    }
  } catch { /* storage unavailable — start empty */ }
  return [];
}

export function saveTransactions(list) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch { /* ignore quota / private mode */ }
}

export function nextCode(list) {
  const max = list.reduce((acc, t) => {
    const n = parseInt(String(t.code || '').replace(/\D/g, ''), 10);
    return Number.isNaN(n) ? acc : Math.max(acc, n);
  }, 0);
  return `FIN-${String(max + 1).padStart(4, '0')}`;
}
